<template>
  <input
    :id="id"
    :type="type"
    v-model="data"
    class="form-control"
    @input="emmitEvent"
    @keydown="emitKeydown"
    @change="emitChange"
  >
</template>

<script>
import IcInput from "./Input";

export default {
  name: "IcInputBankSwift",
  extends: IcInput
};
</script>

<style>
</style>
